import React, { useEffect, useState } from "react";
import {
  createContactsV2,
  enrichProfile,
  getContactDetailsById,
  getEnrichedDataByPersonId,
  revealContact,
} from "../../apis/ext";
import { useMutation } from "react-query";
import EnrichedPhone from "./EnrichedPhone";
import EnrichedEmail from "./EnrichedEmail";
// dayjs import starts
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import localizedFormat from "dayjs/plugin/localizedFormat";
import StripeLoader from "../StripeLoader";
import { Skeleton } from "../ui/skeleton";
import TooltipWrapper from "../TooltipWrapper";
import BulkPhoneEmailButton from "./BulkPhoneEmailButton";
import CRM from "./crm";
import CrmContacts from "./CrmContacts";
import Image from "../Tags/Image";
import { ChevronDownIcon, ChevronUpIcon, Trash2Icon, TrashIcon } from "lucide-react";
import { useStoreBulkReveal } from "../../stores/useStoreBulkReveal";
import { useStoreIntegrations } from "../../stores/useStoreIntegrations";
import toast from "react-hot-toast";
import useFeatureFlag from "../../hooks/useFeatureFlag";
dayjs.extend(localizedFormat);
dayjs.extend(relativeTime);
// dayjs import ends

export default function SingleContactCard({
  profile: profileInit = {},
  enriched = false,
  profile_photo = "",
  userData,
  activeWorkspace,
  contactIsRevealed = null,
  refetchContact = false,
  noCompany = false,
  isBulkRevealing = false,
  checkedItemId = "",
  getCheckedItem,
  cardType = "checkbox",
  crmObjectsConfig = [],
  crmSearchData = [],
  isCRMBulkSearchPending = true,
  activeCrmId = "",
}) {
  const { contactIds, addContactId, updateContactId } = useStoreBulkReveal();
  const isDncFilteringEnabled = useFeatureFlag("dnc-number-filtering");
  const [showContactDetails, setShowContactDetails] = useState(false);
  const [profile, setProfile] = useState(profileInit);
  const { activeDataProviderIntegrations, enabledCRMIntegrations } = useStoreIntegrations();
  // console.log("enabledCRMIntegrations", enabledCRMIntegrations);
  useEffect(() => {
    console.log("checkedItemId", checkedItemId);
    if (profile?.contact_id) {
      console.log("profile checkedItemId", profile);
      updateContactId(profile?.contact_id, { checked: checkedItemId === profile.person_id ? true : false });
    }
  }, [checkedItemId, profile]);

  // generate contact details revealed event

  // create custom event to send contact revealed.

  const [isContactRevealedEventGenerated, setIsContactRevealedEventGenerated] = useState(false);
  const generateContactRevealedEvent = (enrichedData) => {
    const newevent = new CustomEvent("contact_revealed", {
       detail: { profile_id: enrichedData?.id, contact_id: enrichedData?.id, person_id: enrichedData?.person?.id },
    });
    window.dispatchEvent(newevent);

    let contact_details_found = {
      work_email: false,
      personal_email: false,
      direct_phone: false,
      mobile_phone: false,
      hq_phone: false,
    };

    if (enrichedData && enrichedData.email_addresses && enrichedData.email_addresses.length > 0) {
      contact_details_found.work_email = enrichedData.email_addresses.some((e) => e.type === "Work");
      contact_details_found.personal_email = enrichedData.email_addresses.some((e) => e.type === "Personal");
    }
    if (enrichedData && enrichedData.phone_numbers && enrichedData.phone_numbers.length > 0) {
      contact_details_found.direct_phone = enrichedData.phone_numbers.some((e) => e.type === "Direct");
      contact_details_found.mobile_phone = enrichedData.phone_numbers.some((e) => e.type === "Mobile");
      contact_details_found.hq_phone = enrichedData.phone_numbers.some((e) => e.type === "Work HQ");
    }
    console.log("contact_details_found", contact_details_found);
    // useCaptureEvent("EXP_Person_RevealContactBtn", {
    //   contact_details_found: contact_details_found,
    // });
    setIsContactRevealedEventGenerated(true);
  };

  // ends contact details event

  // create contact
  const [contactId, setContactId] = useState("");
  const [isEnriched, setIsEnriched] = useState(false);
  const createContactsV2Fn = useMutation("enrich_profile", createContactsV2, {
    onSuccess(data, variables, context) {
      console.log("createContactsV2Fn", data);
      // toast.success(data?.message);
      if (data && data?.data && data?.data?.contacts && data?.data?.contacts.length > 0) {
        // let arr = data?.data?.contacts.map((el) => el.contact_id);
        setContactId(data?.data?.contacts[0]?.contact_id);

        handleRevealContactDetailsClick(data?.data?.contacts[0]?.contact_id);
      }
    },
    onError(error) {
      console.log(error);
    },
  });

  useEffect(() => {
    if (profile?.contact_id) {
      setContactId(profile?.contact_id);
    }
  }, [profile?.contact_id]);

  const handleCreateContactsV2 = (person_id) => {
    if (createContactsV2Fn.isLoading) {
      return;
    }
    createContactsV2Fn.mutate({
      data: {
        contacts: [{ person_id: person_id }],
      },
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };
  // create contact ends

  // const revealContactFn = useMutation("enrich_profile", enrichProfile, {
  //   onSuccess(data, variables, context) {
  //     console.log("enrich_profile enriched", data);
  //     if (data && data.list && data.list.contacts && data.list.contacts.length > 0) {
  //       let contact = data.list.contacts[0];
  //       setProfile(contact);
  //       if (contactIsRevealed) {
  //         contactIsRevealed(contact);
  //         setShowContactDetails(true);
  //       }
  //     }
  //   },
  //   onError(error) {
  //     console.log(error);
  //   },
  // });
  const revealContactFn = useMutation("enrich_profile", revealContact, {
    onSuccess(data, variables, context) {
      console.log("data", data);

      // setContactId(profile.contact_id);

      setIsEnriched(true);
      setShowContactDetails(true);

      setTimeout(() => {
        setIsEnriched(false);
      }, 1000);
    },
    onError(error) {
      console.log(error);
      setIsEnriched(false);
    },
  });

  const handleRevealContactDetailsClick = (contactId) => {
    const construct_payload = {
      settings: {
        verify: ["work_email", "mobile_phone", "personal_email"],
      },
      requirements: ["mobile_phone", "direct_phone", "work_email", "personal_email"],
      enrichment_type: "People",
      records: [
        {
          contact_id: contactId,
        },
      ],
    };
    console.log("payload", construct_payload);
    revealContactFn.mutate({
      data: {
        ...construct_payload,
      },
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  useEffect(() => {
    if (contactId && isEnriched) {
      handleGetContactDetailsById(contactId);
    }
  }, [isEnriched, contactId]);

  const getContactDetailsByIdFn = useMutation("get_contact_details", getContactDetailsById, {
    onSuccess(data, variables, context) {
      console.log("get_contact_details", data);
      let newdata = data;
      newdata.current_company.linkedin_urls = [newdata?.current_company?.linkedin_url];
      newdata.contact_id = data.id;
      newdata.person_id = profileInit.id;
      setProfile({ ...newdata, fromContactId: true, fromPersonId: false });

      addContactId({
        id: data?.id,
        enrichment_lists: data.enrichment_lists ? data.enrichment_lists : [],
        person_id: profileInit?.person_id,
      });
    },
    onError(error) {
      console.log(error);
    },
  });

  const handleGetContactDetailsById = (id = "") => {
    getContactDetailsByIdFn.mutate({
      id: id ? id : profile?.contact_id,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  useEffect(() => {
    if (activeWorkspace && activeWorkspace.id && profileInit && profileInit.contact_id) {
      handleGetContactDetailsById();
    }
  }, []);
  useEffect(() => {
    if (activeWorkspace && activeWorkspace.id && profileInit && profileInit.person_id && refetchContact) {
      handleGetEnrichedDataByPersonId();
    }
  }, [refetchContact]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      const handleRunSearch = (event) => {
        if (activeWorkspace && activeWorkspace.id && profileInit && profileInit.person_id && refetchContact) {
          handleGetEnrichedDataByPersonId();
        }
      };
      window.addEventListener("person_record_created", handleRunSearch);
      return () => {
        window.removeEventListener("person_record_created", handleRunSearch);
      };
    }
  }, []);

  const getEnrichedDataBypersonIdFn = useMutation(
    "get_enrichmentData_by_person_id",
    getEnrichedDataByPersonId,
    {
      onSuccess(data, variables, context) {
        let persondata = data.data;

        if (persondata?.contacts && persondata?.contacts.length > 0) {
          handleGetContactDetailsById(persondata?.contacts?.[0]?.id);
          setContactId(persondata?.contacts?.[0]?.id);
          setIsEnriched(true);
        }
      },
      onError(error) {
        console.log(error);
      },
    }
  );

  const handleGetEnrichedDataByPersonId = () => {
    getEnrichedDataBypersonIdFn.mutate({
      id: profile.person_id,
      options: {
        headers: { "X-Workspace-Id": activeWorkspace?.id },
      },
    });
  };

  useEffect(() => {
    const doPolling = () => {
      if (profile && profile.contact_id && !revealContactFn.isLoading) {
        handleGetContactDetailsById();
      }
    };

    // Start polling
    const intervalId = setInterval(doPolling, 5000); // 5000ms = 5 seconds

    if (profile && profile.enrichment_lists && profile.enrichment_lists.length > 0) {
      const hasPendingInTimeline = profile.enrichment_lists.some(
        (item) => item.status.toLowerCase() === "queued" || item.status.toLowerCase() === "running"
      );
      const hasPendingInMobile =
        profile.phone_numbers &&
        profile.phone_numbers.length > 0 &&
        profile.phone_numbers.some(
          (item) =>
            item.verification && ["running", "pending"].includes(item.verification.status.toLowerCase())
        );
      const hasPendingInEmail =
        profile.email_addresses &&
        profile.email_addresses.length > 0 &&
        profile.email_addresses.some(
          (item) =>
            item.verification && ["running", "pending"].includes(item.verification.status.toLowerCase())
        );
      const hasPendingInMobileAdvanceVerification =
        profile.phone_numbers &&
        profile.phone_numbers.length > 0 &&
        profile.phone_numbers.some(
          (item) =>
            item.verification &&
            item.verification.advanced_verification &&
            (item.verification.advanced_verification.status.toLowerCase() === "queued" ||
              item.verification.advanced_verification.status.toLowerCase() === "running")
        );
      if (!hasPendingInTimeline) {
        // If no items are 'Pending', stop polling
        if (
          !hasPendingInMobile &&
          !hasPendingInEmail &&
          !isContactRevealedEventGenerated &&
          (refetchContact || revealContactFn.isSuccess)
        ) {
          generateContactRevealedEvent(profile);
        }
        if (!hasPendingInMobile && !hasPendingInEmail && !hasPendingInMobileAdvanceVerification) {
          clearInterval(intervalId);
        }
      }
    }
    if (profile && profile.enrichment_lists && profile.enrichment_lists.length === 0) {
      clearInterval(intervalId);
    }

    // Cleanup function to clear the interval when the component unmounts or the effect re-runs
    return () => clearInterval(intervalId);
  }, [profile, activeWorkspace && activeWorkspace.id, isEnriched, refetchContact]); // Empty dependency array means this effect runs only once on mount

  const processSourceData = (sourceData) => {
    // Group data by 'integration_config.integration.key'
    const grouped = sourceData.reduce((acc, item) => {
      const key = item?.integration_config?.integration?.key;
      if (!acc[key]) {
        acc[key] = {
          ...item,
          data_found: item.status === "Success",
          enrichment_data: [
            {
              enrichment_mode: item.enrichment_mode,
              status: item.status,
            },
          ],
        };
      } else {
        acc[key].enrichment_data.push({
          enrichment_mode: item.enrichment_mode,
          status: item.status,
        });
        // Update data_found if any of the statuses is 'Found'
        if (item.status === "Success") {
          acc[key].data_found = true;
        }
      }
      return acc;
    }, {});

    // Convert the grouped data back into an array and adjust fields
    return Object.values(grouped).map((item) => {
      // Remove fields that are not required in the final output
      delete item.enrichment_mode;
      delete item.status;
      return item;
    });
  };

  const groupByIntegrationWithMapping = (actions) => {
    const grouped = {};

    const aggregateMapping = (mapping = []) => {
      const mappingTypes = [
        {
          key: "phone",
          requirements: ["mobile_phone", "direct_phone", "work_phone", "hq_phone"],
        },
        {
          key: "email",
          requirements: ["work_email", "personal_email"],
        },
      ];

      return mappingTypes
        .map(({ key, requirements }) => {
          const relevantMappings = mapping.filter((mapItem) =>
            mapItem?.requirements?.some((req) => requirements.includes(req))
          );

          if (relevantMappings.length === 0) return null;

          const hasSuccess = relevantMappings.some((item) => item.status === "Success");
          const hasError = relevantMappings.some((item) => item.status === "Error");

          const status = hasSuccess
            ? "Success"
            : hasError
              ? "Error"
              : relevantMappings[0]?.status || "No Match";

          const error_message =
            status === "Success"
              ? ""
              : relevantMappings.find((item) => item?.error_message)?.error_message || "";

          return {
            requirements: [key],
            error_message,
            status,
          };
        })
        .filter(Boolean);
    };

    actions &&
      actions.length > 0 &&
      actions.forEach((action) => {
        const key = action?.integration_config?.integration?.key;

        const mappingItem = {
          requirements: action?.requirements,
          error_message: action?.error_message,
          status: action?.status,
        };

        if (!grouped[key]) {
          // clone the original action for base and initialize mapping array
          grouped[key] = {
            ...action,
            mapping: [mappingItem],
          };
        } else {
          grouped[key]?.mapping?.push(mappingItem);
        }
      });

    return Object.values(grouped).map((item) => ({
      ...item,
      mapping: aggregateMapping(item?.mapping),
    }));
  };

  const filterByFound = (arr) => {
    return arr.filter((obj) => obj.data_found === true);
  };

  const shouldShowBlur = () => {
    if (profile && profile?.enrichment_lists && profile?.enrichment_lists.length === 0) {
      return true;
    } else if (
      profile &&
      profile.enrichment_lists &&
      profile.enrichment_lists.some(
        (item) => item.status.toLowerCase() === "queued" || item.status.toLowerCase() === "running"
      ) &&
      filterByFound(processSourceData(profile.enrichment_lists)).length === 0
    ) {
      return true;
    } else {
      return false;
    }
  };
  const isEnrichmentTimelineRunning = () => {
    if (
      profile &&
      profile.enrichment_lists &&
      profile.enrichment_lists.some(
        (item) => item.status.toLowerCase() === "queued" || item.status.toLowerCase() === "running"
      )
    ) {
      return true;
    } else {
      return false;
    }
  };

  const showStripeLoader = () => {
    if (
      profile &&
      profile.enrichment_lists &&
      profile.enrichment_lists.some(
        (item) => item.status.toLowerCase() === "queued" || item.status.toLowerCase() === "running"
      )
    ) {
      return <StripeLoader />;
    } else if (getContactDetailsByIdFn.isLoading || revealContactFn.isLoading) {
      return <StripeLoader />;
    }
  };

  // crm contacts

  const [crmPhonesEmails, setCRMPhonesEmails] = useState({
    phone_numbers: [],
    email_addresses: [],
  });

  const [enrichedList, setEnrichedList] = useState([]);
  useEffect(() => {
    setEnrichedList(profile?.enrichment_lists);
    console.log("current_profile", profile);
  }, [profile?.enrichment_lists]);

  /// timeline
  const returnBadgeClasses = (status) => {
    if (status === "Error") {
      return "bg-error-50 text-error-700 border-error-200";
    } else if (status === "Success") {
      return "bg-success-50 text-success-700 border-success-200";
    } else {
      return "bg-gray-50 text-gray-400 border-border ";
    }
  };
  const returnBadgeImg = (status) => {
    if (status === "Error") {
      return "-red";
    } else if (status === "Success") {
      return "-green";
    } else {
      return "";
    }
  };

  const returnTimelineBadge = (status = "", enrichment_mode = "", error = "") => {
    const emailModes = ["work_email", "personal_email", "email"];
    const phoneModes = ["mobile_phone", "direct_phone", "work_phone", "hq_phone", "phone"];

    return (
      <TooltipWrapper content={error} contentClassName="max-w-[200px]">
        <span
          className={`inline-flex items-center space-x-2 text-[12px] border ${returnBadgeClasses(status)} pl-3 pr-2 py-0.5 rounded-[20px] mr-1`}
        >
          {emailModes.includes(enrichment_mode) && (
            <Image className="h-5 w-5 no-invert" src={`/images/ext/email${returnBadgeImg(status)}.svg`} />
          )}
          {phoneModes.includes(enrichment_mode) && (
            <Image className="h-5 w-5 no-invert" src={`/images/ext/phone${returnBadgeImg(status)}.svg`} />
          )}
          <span>{status}</span>
        </span>
      </TooltipWrapper>
    );
  };

  const [toggleEnrichData, setToggleEnrichData] = useState(false);
  const handleToggleEnrichData = () => {
    setToggleEnrichData(!toggleEnrichData);
  };

  return (
    <div
      className={`py-4 pt-3.5 px-5 items-center border  ${
        noCompany ? "border-gray-300 bg-gray-300" : "border-input bg-background"
      }   rounded-[14px] relative`}
    >
      <div className="absolute left-2.5 w-[94%] mx-auto top-0 overflow-hidden h-0.5 ">
        {showStripeLoader()}
      </div>

      <div className="flex items-center space-x-3 justify-between">
        <div className="inline-flex items-center space-x-3">
          {enriched ? (
            <>
              {cardType === "checkbox" && (
                <input
                  disabled={getContactDetailsByIdFn.isLoading}
                  checked={checkedItemId === profile.person_id}
                  onChange={() => {
                    getCheckedItem(profile);
                  }}
                  type="checkbox"
                  className="mr-1 h-4 w-4 rounded border-gray-300 text-brand-700 focus:ring-brand-700 dark:text-brand-200"
                />
              )}

              <Image
                nobaseurl={profile_photo && !profile_photo.includes("data:image/") ? true : false}
                src={
                  profile_photo && !profile_photo.includes("data:image/")
                    ? profile_photo
                    : "/images/ext/user-gd.svg"
                }
                width={40}
                height={40}
                className={`rounded-full w-10 h-10 no-invert ${
                  (!profile_photo || profile_photo.includes("data:image/")) && "p-[6px]"
                }`}
              />
            </>
          ) : (
            <Image
              nobaseurl={profile_photo && !profile_photo.includes("data:image/") ? true : false}
              src={
                profile?.person_profile_photo && !profile?.person_profile_photo.includes("data:image/")
                  ? profile?.person_profile_photo
                  : "/images/ext/user-gd.svg"
              }
              width={40}
              height={40}
              className="rounded-full w-10 h-10 no-invert"
            />
          )}
          <div>
            <a
              className={`text-[16px] text-gray-900 block font-bold`}
              href={
                (profile &&
                  profile?.linkedin_urls &&
                  profile?.linkedin_urls.length > 0 &&
                  profile?.linkedin_urls[0]) ||
                profile?.linkedin_url
              }
              target="_blank"
            >
              {profile?.name?.full ? profile?.name?.full : `${profile?.name?.first} ${profile?.name?.last}`}
            </a>
            {profile.work_experiences && profile.work_experiences.length > 0 ? (
              <span className="text-[12px] text-gray-900 block mt-0.5">
                {profile.current_job_title ? profile.current_job_title : profile.current_job_title} at{" "}
                <a
                  href={
                    profile?.current_company &&
                    profile?.current_company?.linkedin_urls &&
                    profile?.current_company?.linkedin_urls.length > 0 &&
                    profile.current_company?.linkedin_urls[0]
                  }
                  className="text-brand-700 font-bold"
                  target="_blank"
                >
                  {profile?.current_company?.name}
                </a>
              </span>
            ) : (
              <>
                {profile?.current_job_title && (
                  <span className="text-[12px] text-gray-900 block mt-0.5">
                    {profile?.current_job_title}{" "}
                    {profile?.current_company?.name && (
                      <>
                        at{" "}
                        <a
                          href={
                            profile?.current_company &&
                            profile?.current_company?.linkedin_urls &&
                            profile?.current_company?.linkedin_urls.length > 0 &&
                            profile.current_company?.linkedin_urls[0]
                          }
                          className="text-brand-700 font-bold"
                          target="_blank"
                        >
                          {profile?.current_company?.name}
                        </a>
                      </>
                    )}
                  </span>
                )}
              </>
            )}
          </div>
        </div>
        {cardType === "delete" && (
          <button
            onClick={() => {
              getCheckedItem(profile);
            }}
            className="flex items-center justify-center rounded-md text-red-500 border border-error-300 min-w-[28px] h-7"
          >
            <Trash2Icon className="h-3 w-3" />
          </button>
        )}
      </div>
      {profile && (
        <div className="mt-3 flex items-center space-x-2">
          {!noCompany && (
            <CRM
              className="mt-0 relative inline-flex crm__wrapper__bulk__reveal"
              activeWorkspace={activeWorkspace}
              recordData={{
                name: profile?.name?.full ? profile?.name?.full : profile?.name?.first,
                first_name: profile?.name?.first,
                last_name: profile?.name?.last,
                company: profile?.current_company?.name,
                id: profile.contact_id ? profile.contact_id : profile?.person_id,
                linkedin_url: profile?.linkedin_url,
                company_linkedin_url: profile?.current_company?.linkedin_url,
                contact_id: profile.contact_id ? profile.contact_id : "",
                person_id: profile.person_id ? profile.person_id : "",
                organization_id: profile?.current_company?.organization_ids?.system,
              }}
              activeCrm={activeCrmId}
              type="person"
              getCRMPhonesEmails={(data) => {
                setCRMPhonesEmails(data);
              }}
              crmObjectsConfig={crmObjectsConfig}
              contactRevealed={
                profile?.enrichment_lists && profile?.enrichment_lists.length > 0 ? true : false
              }
              getActiveCRMID={(id) => {
                console.log("getActiveCRMID", id);
                // setActiveCrmId(id);
              }}
              isBulkEnrichment={enabledCRMIntegrations && enabledCRMIntegrations.length > 0 ? true : false}
              crmSearchData={crmSearchData}
              isCRMBulkSearchPending={isCRMBulkSearchPending}
            />
          )}
          {profile.enrichment_lists && profile.enrichment_lists.length === 0 && (
            <button
              className="text-[14px] inline-flex justify-center items-center leading-none py-2 h-10 space-x-2 px-4 rounded-[8px] text-brand-600 bg-background border border-brand-600 font-semibold"
              onClick={() => {
                if (activeDataProviderIntegrations?.length === 0) {
                  toast.error("You do not have any active Data provider integration.");
                } else {
                  if (profile && !profile.contact_id) {
                    createContactsV2Fn.isLoading ? void 0 : handleCreateContactsV2(profile.id);
                  }
                  if (profile && profile.contact_id) {
                    revealContactFn.isLoading ? void 0 : handleRevealContactDetailsClick(profile.contact_id);
                  }
                }
              }}
              disabled={revealContactFn.isLoading || isBulkRevealing ? true : false}
            >
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M6.98356 7.71098C7.56356 8.919 8.35422 10.0512 9.35553 11.0525C10.3568 12.0538 11.4891 12.8445 12.6971 13.4245C12.801 13.4744 12.8529 13.4993 12.9187 13.5185C13.1523 13.5866 13.4392 13.5377 13.637 13.396C13.6927 13.3561 13.7403 13.3085 13.8356 13.2132C14.1269 12.9219 14.2726 12.7762 14.4191 12.681C14.9715 12.3218 15.6837 12.3218 16.2361 12.681C16.3825 12.7762 16.5282 12.9219 16.8196 13.2132L16.9819 13.3756C17.4248 13.8185 17.6462 14.0399 17.7665 14.2777C18.0058 14.7507 18.0058 15.3093 17.7665 15.7822C17.6462 16.0201 17.4248 16.2415 16.9819 16.6844L16.8506 16.8157C16.4092 17.2571 16.1886 17.4777 15.8885 17.6463C15.5556 17.8333 15.0385 17.9678 14.6567 17.9666C14.3126 17.9656 14.0774 17.8989 13.607 17.7654C11.0792 17.0479 8.69387 15.6942 6.70388 13.7042C4.7139 11.7142 3.36017 9.32888 2.6427 6.80105C2.50919 6.33068 2.44244 6.0955 2.44141 5.75137C2.44028 5.36952 2.57475 4.85245 2.76176 4.51952C2.9303 4.2195 3.15098 3.99882 3.59233 3.55747L3.72369 3.42611C4.16656 2.98324 4.388 2.7618 4.62581 2.64152C5.09878 2.40229 5.65734 2.40229 6.1303 2.64152C6.36812 2.7618 6.58955 2.98324 7.03242 3.42611L7.19481 3.5885C7.48615 3.87984 7.63182 4.0255 7.72706 4.17199C8.08622 4.7244 8.08622 5.43655 7.72706 5.98896C7.63182 6.13544 7.48615 6.28111 7.19481 6.57244C7.09955 6.6677 7.05192 6.71533 7.01206 6.77101C6.87038 6.96887 6.82146 7.25575 6.88957 7.48938C6.90873 7.55512 6.93367 7.60708 6.98356 7.71098Z"
                  stroke="var(--brand-700)"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span>Reveal contact</span>
              {(revealContactFn.isLoading || isBulkRevealing) && (
                <div className="loader_circle inline-block"></div>
              )}
            </button>
          )}
          {!enriched && (
            <div>
              <TooltipWrapper content={noCompany ? "No account associated with this person" : ""}>
                <button
                  disabled={noCompany}
                  className={`text-[14px] inline-flex justify-center items-center  py-2 h-9 space-x-2 px-4 rounded-[8px] text-brand-600 bg-background border border-brand-600 font-semibold ${
                    noCompany && "opacity-60"
                  }`}
                >
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.98356 7.71098C7.56356 8.919 8.35422 10.0512 9.35553 11.0525C10.3568 12.0538 11.4891 12.8445 12.6971 13.4245C12.801 13.4744 12.8529 13.4993 12.9187 13.5185C13.1523 13.5866 13.4392 13.5377 13.637 13.396C13.6927 13.3561 13.7403 13.3085 13.8356 13.2132C14.1269 12.9219 14.2726 12.7762 14.4191 12.681C14.9715 12.3218 15.6837 12.3218 16.2361 12.681C16.3825 12.7762 16.5282 12.9219 16.8196 13.2132L16.9819 13.3756C17.4248 13.8185 17.6462 14.0399 17.7665 14.2777C18.0058 14.7507 18.0058 15.3093 17.7665 15.7822C17.6462 16.0201 17.4248 16.2415 16.9819 16.6844L16.8506 16.8157C16.4092 17.2571 16.1886 17.4777 15.8885 17.6463C15.5556 17.8333 15.0385 17.9678 14.6567 17.9666C14.3126 17.9656 14.0774 17.8989 13.607 17.7654C11.0792 17.0479 8.69387 15.6942 6.70388 13.7042C4.7139 11.7142 3.36017 9.32888 2.6427 6.80105C2.50919 6.33068 2.44244 6.0955 2.44141 5.75137C2.44028 5.36952 2.57475 4.85245 2.76176 4.51952C2.9303 4.2195 3.15098 3.99882 3.59233 3.55747L3.72369 3.42611C4.16656 2.98324 4.388 2.7618 4.62581 2.64152C5.09878 2.40229 5.65734 2.40229 6.1303 2.64152C6.36812 2.7618 6.58955 2.98324 7.03242 3.42611L7.19481 3.5885C7.48615 3.87984 7.63182 4.0255 7.72706 4.17199C8.08622 4.7244 8.08622 5.43655 7.72706 5.98896C7.63182 6.13544 7.48615 6.28111 7.19481 6.57244C7.09955 6.6677 7.05192 6.71533 7.01206 6.77101C6.87038 6.96887 6.82146 7.25575 6.88957 7.48938C6.90873 7.55512 6.93367 7.60708 6.98356 7.71098Z"
                      stroke="var(--brand-700)"
                      stroke-width="1.66667"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span>Reveal contact</span>
                </button>
              </TooltipWrapper>
            </div>
          )}
          {profile.enrichment_lists && profile.enrichment_lists.length > 0 && (
            <>
              <span
                className="block"
                onClick={() => {
                  setShowContactDetails(!showContactDetails);
                }}
              >
                <BulkPhoneEmailButton
                  phonesLength={profile?.phone_numbers?.length + crmPhonesEmails.phone_numbers.length}
                  emailsLength={profile?.email_addresses?.length + crmPhonesEmails.email_addresses.length}
                  isLoading={revealContactFn.isLoading || isBulkRevealing}
                />
              </span>
            </>
          )}
        </div>
      )}

      {showContactDetails && (
        <CrmContacts crmPhonesEmails={crmPhonesEmails} spaceClasses="border-t pt-4 mt-4" />
      )}

      {enriched &&
        profile &&
        profile?.enrichment_lists &&
        profile?.enrichment_lists.length > 0 &&
        showContactDetails && (
          <div className="mt-4">
            <div className="h-[1px] bg-border mx-auto my-3"></div>
            <div className="pl-1">
              {(() => {
                const filteredPhoneNumbers = isDncFilteringEnabled
                  ? profile?.phone_numbers?.filter((number) => !number.dnc)
                  : profile?.phone_numbers;
                return filteredPhoneNumbers && filteredPhoneNumbers.length > 0 ? (
                filteredPhoneNumbers.map((number, index) => (
                  <>
                    <EnrichedPhone
                      number={number}
                      type={number?.type}
                      phoneValue={number?.value}
                      isValid={
                        number?.verification?.status !== "Completed" ? null : number?.verification?.is_valid
                      }
                      lineType={number?.verification?.line_type}
                      foundFrom={{
                        name: number?.integration_config?.integration?.display_name,
                        key: number?.integration_config?.integration?.key,
                      }}
                      feedback={number?.feedback}
                      value={
                        number?.verification?.status === "Completed"
                          ? number?.verification?.international_format
                            ? number?.verification?.international_format
                            : number?.value
                          : number?.value
                      }
                      activeWorkspace={activeWorkspace}
                      contactId={profile.id}
                      onSuccess={() => {
                        handleGetContactDetailsById();
                      }}
                      showDevider={index + 1 !== filteredPhoneNumbers.length ? true : false}
                      advanceVerification={{
                        verified_at_simple: number?.verification?.verified_at
                          ? dayjs(number?.verification?.verified_at).format("hh:mm A, MM/DD/YY")
                          : "",
                        status: number?.verification?.advanced_verification?.status,
                        verification_status: number?.verification?.advanced_verification?.verification_status,
                        verified_at: number?.verification?.advanced_verification?.verified_at
                          ? dayjs(number?.verification?.advanced_verification?.verified_at).format(
                              "hh:mm A, MM/DD/YY"
                            )
                          : "",
                      }}
                    />
                  </>
                ))
              ) : (
                <>
                  <>
                    {shouldShowBlur() ? (
                      <span className="text-[12px] block mt-2 blur-[2px] pointer-events-none unselectable">
                        +1 9876543210
                      </span>
                    ) : (
                      <>
                        {getContactDetailsByIdFn.isLoading || isEnrichmentTimelineRunning() ? (
                          <Skeleton className="h-[20px] w-7/12 mt-2" />
                        ) : (
                          <span className="text-[12px] block mt-2">No phones found.</span>
                        )}
                      </>
                    )}
                  </>
                </>
              );
              })()}
            </div>
            <div className="pl-1">
              <div className="w-[240px] h-[1px] bg-border mx-auto my-3"></div>

              {profile?.email_addresses && profile?.email_addresses.length > 0 ? (
                profile?.email_addresses.map((email, index) => (
                  <>
                    <EnrichedEmail
                      email={email}
                      contactId={profile.id}
                      feedback={email?.feedback}
                      foundFrom={{
                        name: email?.integration_config?.integration?.display_name,
                        key: email?.integration_config?.integration?.key,
                      }}
                      value={email?.value}
                      badge={email?.verification && email?.verification?.result}
                      activeWorkspace={activeWorkspace}
                      onSuccess={() => {
                        handleGetContactDetailsById();
                      }}
                      autoVerify={userData?.preferences?.chrome_ext_auto_verify_email ? true : false}
                      // customEmailVerify={customEmailVerify}
                      // customEmailVerifyToast={
                      //   profile &&
                      //   emailsWithoutVerification &&
                      //   emailsWithoutVerification.length > 0
                      //     ? true
                      //     : false
                      // }
                      type={email?.type}
                      showDevider={index + 1 !== profile?.email_addresses.length ? true : false}
                      isVerifying={(status) => {
                        // setEmailVerifyStatus(status);
                      }}
                    />
                  </>
                ))
              ) : (
                <>
                  <>
                    {shouldShowBlur() ? (
                      <span className="text-[12px] block mt-2 blur-[2px] pointer-events-none unselectable">
                        reveal@example.com
                      </span>
                    ) : (
                      <>
                        {getContactDetailsByIdFn.isLoading || isEnrichmentTimelineRunning() ? (
                          <Skeleton className="h-[20px] w-7/12 mt-2" />
                        ) : (
                          <span className="text-[12px] block mt-2">No emails found.</span>
                        )}
                      </>
                    )}
                  </>
                </>
              )}
            </div>

            <>
              <div className="w-[240px] h-[1px] bg-border mx-auto mt-4 mb-2"></div>
              <div className={`py-1 px-0 space-y-5 ${toggleEnrichData && "pb-0"}`}>
                <h3
                  className="text-[14px] font-semibold flex justify-center items-center cursor-pointer"
                  onClick={handleToggleEnrichData}
                >
                  <span className="inline-flex text-gray-600">
                    {getContactDetailsByIdFn.isLoading ||
                    profile.enrichment_lists.some(
                      (item) =>
                        item.status.toLowerCase() === "queued" || item.status.toLowerCase() === "running"
                    ) ? (
                      <div className="inline-flex items-center">
                        <div className="loader_circle inline-block mr-2"></div>
                        Fetching Contact Info
                      </div>
                    ) : (
                      <>
                        {enrichedList && enrichedList.length > 0 && filterByFound(enrichedList).length > 0 ? (
                          <>
                            <Image src="/images/ext/multi_found_info.svg" className="mr-1 no-invert" />
                            Fetched from {filterByFound(enrichedList).length}{" "}
                            {filterByFound(enrichedList).length === 1 ? "provider" : "providers"}
                          </>
                        ) : (
                          <span className=" inline-flex items-center">
                            {/* <img
                                      src="images/ext/multi_found.svg"
                                      className="mr-1 no-invert"
                                    />
                                    Enrichment Timeline */}
                          </span>
                        )}
                      </>
                    )}
                  </span>
                  {toggleEnrichData ? (
                    <ChevronUpIcon className="ml-2" width={18} />
                  ) : (
                    <ChevronDownIcon className="ml-2" width={18} />
                  )}
                </h3>

                {toggleEnrichData &&
                  enrichedList &&
                  enrichedList.length > 0 &&
                  enrichedList.map((item, itemIndex) => (
                    <div className={enrichedList.length !== itemIndex + 1 && "border-b pb-2"}>
                      <div className="flex items-center mb-3 justify-between">
                        <div className="inline-flex items-center">
                          <div className="h-8 w-8 flex-shrink-0">
                            {item.created_by && (
                              <Image
                                className="h-8 w-8 rounded-full bg-gray-50 border border-border p-1.5 no-invert"
                                src={"/images/icons/untitledui/user.svg"}
                                alt=""
                              />
                            )}
                          </div>
                          <div className="ml-3">
                            <div className="font-bold text-foreground">{item.created_by?.name}</div>
                            <div className="mt-0 text-paragraph">{dayjs(item?.created_at).fromNow()}</div>
                          </div>
                        </div>
                        {item && item.tasks && item.tasks.length > 0 && (
                          <TooltipWrapper content={`Credit consumed: ${item.tasks[0]?.credit_consumed}`}>
                            {item.tasks[0]?.credit_consumed ? (
                              <Image
                                className="no-invert"
                                src={"/images/ext/credit-consumed-orange.svg"}
                                alt=""
                              />
                            ) : (
                              <Image
                                className="no-invert"
                                src={"/images/ext/credit-consumed-grey.svg"}
                                alt=""
                              />
                            )}
                          </TooltipWrapper>
                        )}
                      </div>
                      <div className="flow-root text-[12px] slide-in">
                        <ul role="list">
                          {item &&
                            item.tasks &&
                            item.tasks.length > 0 &&
                            item.tasks[0].actions &&
                            item.tasks[0].actions.length > 0 &&
                            groupByIntegrationWithMapping(item.tasks[0].actions).map((timeline, index) => (
                              <li>
                                <div className="relative pb-3">
                                  {groupByIntegrationWithMapping(item.tasks[0].actions).length !==
                                    index + 1 && (
                                    <span
                                      className="absolute left-4 top-4 -ml-px h-full w-0.5 bg-gray-200"
                                      aria-hidden="true"
                                    ></span>
                                  )}
                                  <div className="relative">
                                    <div className="flex space-x-3 items-center">
                                      <TooltipWrapper
                                        content={timeline?.integration_config?.integration?.display_name}
                                      >
                                        <span className="h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center">
                                          {timeline?.integration_config?.integration ? (
                                            <Image
                                              className="no-invert"
                                              src={`/images/ext/providers/${timeline?.integration_config?.integration?.key}.svg`}
                                              alt=""
                                              style={{ width: "auto", height: 19 }}
                                            />
                                          ) : (
                                            <svg
                                              className="h-5 w-5 text-white"
                                              viewBox="0 0 20 20"
                                              fill="currentColor"
                                              aria-hidden="true"
                                            >
                                              <path d="M10 8a3 3 0 100-6 3 3 0 000 6zM3.465 14.493a1.23 1.23 0 00.41 1.412A9.957 9.957 0 0010 18c2.31 0 4.438-.784 6.131-2.1.43-.333.604-.903.408-1.41a7.002 7.002 0 00-13.074.003z" />
                                            </svg>
                                          )}
                                        </span>
                                      </TooltipWrapper>
                                      <span className="text-[13px] text-text-700 font-semibold">
                                        {timeline?.integration_config?.integration?.display_name}
                                        {/* <span className="inline-block text-[10px] font-normal ml-2">
                                                <TooltipWrapper
                                                  content={
                                                    item?.created_at ? dayjs(item?.created_at).format("LLLL") : ""
                                                  }
                                                >
                                                  {item?.created_at ? dayjs(item?.created_at).fromNow() : ""}
                                                </TooltipWrapper>
                                              </span> */}
                                      </span>
                                    </div>
                                    <div className="pl-11 mt-0">
                                      {timeline &&
                                        timeline.mapping &&
                                        timeline.mapping.length > 0 &&
                                        timeline.mapping.map((data) => (
                                          <div className="inline-flex mb-2">
                                            {returnTimelineBadge(
                                              data?.status,
                                              data?.requirements?.[0],
                                              data?.error_message
                                            )}
                                          </div>
                                        ))}
                                    </div>
                                  </div>
                                </div>
                              </li>
                            ))}
                        </ul>
                      </div>
                    </div>
                  ))}
              </div>
            </>
          </div>
        )}
    </div>
  );
}
